var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dots-spinner",class:{ 'dots-spinner--loading': _vm.value }},[_c('div',{staticClass:"dots-spinner__spinner"},[_vm._v(" ••• ")])])}
var staticRenderFns = []

export { render, staticRenderFns }